'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listOfFileUploadsForThreadInProps = undefined;

var _reselect = require('reselect');

var _fileUploadsMapForThreadInProps = require('./fileUploadsMapForThreadInProps');

var listOfFileUploadsForThreadInProps = exports.listOfFileUploadsForThreadInProps = (0, _reselect.createSelector)([_fileUploadsMapForThreadInProps.fileUploadsMapForThreadInProps], function (fileUploadsMap) {
  if (!fileUploadsMap) {
    return null;
  }

  return fileUploadsMap.toList();
});


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/selectors/listOfFileUploadsForThreadInProps.js
// module id = 661
// module chunks = 2 3